/** Inline stroke icons on a 24-unit grid (2-unit strokes, round joins), drawn from the design boards. */
const P = {
  home: 'M3 10.5L12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  projects: 'M4 21V8l6-4v17M10 21h10V11l-6-3M14 13h2M14 17h2M6 11h2M6 15h2M2 21h20',
  building: 'M4 21V8l6-4v17M10 21h10V11l-6-3M2 21h20',
  office: 'M3 5h18v14H3zM8 9.5a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6zM5.5 16.5c.7-1.6 4.3-1.6 5 0M13 9h5M13 12h5M13 15h3',
  stores: 'M3 7.5l9-4.5 9 4.5v9L12 21l-9-4.5zM3 7.5L12 12l9-4.5M12 12v9',
  cart: 'M6 6h15l-1.6 8H7.4zM6 6L5.2 3H2M8 20.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM18 20.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z',
  money: 'M3 6h18v12H3zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM6 9v.01M18 15v.01',
  clients: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  people: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  person: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  reports: 'M4 20V10M10 20V4M16 20v-7M2 20h20',
  settings: 'M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6',
  approvals: 'M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M9 14l2 2 4-4',
  chevronDown: 'M6 9l6 6 6-6',
  chevronUp: 'M6 15l6-6 6 6',
  chevronRight: 'M9 6l6 6-6 6',
  chevronLeft: 'M15 6l-6 6 6 6',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  panel: 'M3 4h18v16H3zM9 4v16',
  search: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-3.5-3.5',
  calendar: 'M4 5h16v15H4zM4 10h16M9 3v4M15 3v4',
  bell: 'M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 20a2 2 0 0 0 4 0',
  truck: 'M2 6h11v10H2zM13 9h4l4 4v3h-8zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  drop: 'M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z',
  box: 'M3 7.5l9-4.5 9 4.5v9L12 21l-9-4.5zM3 7.5L12 12l9-4.5M12 12v9',
  doc: 'M6 2h9l5 5v15H6zM14 2v6h6M9 13h6M9 17h6',
  file: 'M6 2h9l5 5v15H6zM14 2v6h6',
  bill: 'M6 2h12v20l-3-2-3 2-3-2-3 2zM9 7h6M9 11h6M9 15h4',
  wallet: 'M3 6h18v12H3zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  scale: 'M12 3v18M5 7h14M5 7l-3 7a3.5 3.5 0 0 0 6 0zM19 7l-3 7a3.5 3.5 0 0 0 6 0z',
  sparkle: 'M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8zM19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  download: 'M12 4v12M6 10l6 6 6-6M4 20h16',
  upload: 'M12 20V8M6 14l6-6 6 6M4 4h16',
  camera: 'M3 7h4l2-3h6l2 3h4v13H3zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5 11a7 7 0 0 0 14 0M12 18v3',
  scan: 'M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M7 12h10',
  inbox: 'M3 13l3-8h12l3 8v6H3zM3 13h5l1 3h6l1-3h5',
  menu: 'M4 6h16M4 12h16M4 18h16',
  x: 'M6 6l12 12M18 6L6 18',
  tick: 'M5 12.5l4.5 4.5L19 7.5',
  warn: 'M12 3.5l9.5 16.5h-19zM12 10v4.5M12 17.5v.01',
  issue: 'M4 12h12M12 6l6 6-6 6M20 4v16',
  transfer: 'M4 8h14l-3-3M20 16H6l3 3',
  logout: 'M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 17l5-5-5-5M15 12H3',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  copy: 'M8 8h12v12H8zM4 16V4h12',
  chat: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
  print: 'M6 9V3h12v6M6 18H4v-7h16v7h-2M6 14h12v7H6z',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2',
  torch: 'M8 3h8l-1 6H9zM9 9h6v12H9zM12 13v3',
  gate: 'M3 21V6l9-3 9 3v15M9 21v-8h6v8',
  edit: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v5M12 8v.01',
  card: 'M3 6h18v12H3zM3 10h18M7 15h4',
  image: 'M4 4h16v16H4zM4 16l5-5 4 4 3-3 4 4M15 9h.01',
  timeline: 'M4 6h10M8 12h12M4 18h8',
  external: 'M14 4h6v6M20 4l-9 9M18 14v6H4V6h6',
  globe: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z',
  key: 'M14 10a4 4 0 1 0-3.5 3.9L3 21h4v-2h2v-2h2l1.5-1.5M15.5 7.5h.01',
  lock: 'M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  list: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  hammer: 'M14 4l6 6-3 3-6-6zM11 7L3 15l3 3 8-8',
  refresh: 'M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4',
  qr: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h3v3h-3zM20 14v.01M14 20h.01M17 17h4v4h-4M6 6h1v1H6zM17 6h1v1h-1zM6 17h1v1H6z',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  flag: 'M5 21V4M5 4h12l-2 4 2 4H5',
  check: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM8 12.5l3 3 5-6',
  pause: 'M7 4h4v16H7zM13 4h4v16h-4z',
  play: 'M7 4l13 8-13 8z',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
  ruler: 'M3 17L17 3l4 4L7 21zM7 13l2 2M10 10l2 2M13 7l2 2',
} as const;

export type IconName = keyof typeof P;

const FILLED: Partial<Record<IconName, true>> = { play: true, pause: true };

export function Icon({ name, size = 20, stroke = 1.8, className, title, style }: { name: IconName; size?: number; stroke?: number; className?: string; title?: string; style?: React.CSSProperties }) {
  const filled = FILLED[name];
  return (
    <svg
      className={`icon${className ? ' ' + className : ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke={filled ? 'none' : 'currentColor'}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={style}
    >
      <path d={P[name]} />
    </svg>
  );
}

const BAND = 'M96 .08A26 26 0 0 1 106 2.9V117.1A26 26 0 0 1 96 119.9Z';
const BD = 'M41.7 48.3Q45.6 48.3 48.7 50.3Q51.9 52.4 53.7 56.1Q55.5 59.9 55.5 65Q55.5 70 53.7 73.8Q51.9 77.6 48.7 79.6Q45.6 81.7 41.7 81.7Q38.4 81.7 35.9 80.4Q33.5 79.1 32.2 76.7V81.3H20.8V38.3H32.2V53.2Q33.5 50.9 35.9 49.6Q38.4 48.3 41.7 48.3ZM38.1 58.2Q35.6 58.2 33.9 60Q32.2 61.8 32.2 65Q32.2 68.1 33.9 69.9Q35.6 71.7 38.1 71.7Q40.6 71.7 42.3 69.9Q44 68.1 44 65Q44 61.8 42.3 60Q40.6 58.2 38.1 58.2Z M70.3 48.3Q73.4 48.3 75.9 49.6Q78.4 50.9 79.8 53.2V38.3H91.2V81.3H79.8V76.7Q78.4 79 76 80.3Q73.6 81.7 70.3 81.7Q66.4 81.7 63.2 79.6Q60 77.6 58.2 73.8Q56.4 70 56.4 65Q56.4 59.9 58.2 56.1Q60 52.4 63.2 50.3Q66.4 48.3 70.3 48.3ZM73.9 58.2Q71.4 58.2 69.7 60Q68 61.8 68 65Q68 68.1 69.7 69.9Q71.4 71.7 73.9 71.7Q76.4 71.7 78.1 69.9Q79.8 68.1 79.8 65Q79.8 61.8 78.1 60Q76.4 58.2 73.9 58.2Z';
const WORD = 'M34.3 23.5Q41.2 23.5 46.8 27Q52.4 30.5 55.7 37Q58.9 43.5 58.9 52.1Q58.9 60.7 55.7 67.2Q52.4 73.8 46.8 77.4Q41.2 80.9 34.3 80.9Q28.4 80.9 24 78.6Q19.6 76.2 17.1 72.3V80.1H0V6.1H17.1V32.2Q19.5 28.3 24 25.9Q28.5 23.5 34.3 23.5ZM29.2 38.4Q24.1 38.4 20.6 42.1Q17 45.8 17 52.2Q17 58.6 20.6 62.3Q24.1 66 29.2 66Q34.3 66 37.9 62.2Q41.5 58.5 41.5 52.1Q41.5 45.7 38 42.1Q34.4 38.4 29.2 38.4Z M122 24.3V80.1H104.9V72.5Q102.3 76.2 97.9 78.5Q93.4 80.7 88 80.7Q81.6 80.7 76.7 77.9Q71.8 75 69.1 69.6Q66.4 64.2 66.4 56.9V24.3H83.4V54.6Q83.4 60.2 86.3 63.3Q89.2 66.4 94.1 66.4Q99.1 66.4 102 63.3Q104.9 60.2 104.9 54.6V24.3Z M131.7 9.3Q131.7 5.3 134.6 2.7Q137.4 0 141.9 0Q146.3 0 149.2 2.7Q152 5.3 152 9.3Q152 13.2 149.2 15.9Q146.3 18.5 141.9 18.5Q137.4 18.5 134.6 15.9Q131.7 13.2 131.7 9.3ZM150.4 24.3V80.1H133.3V24.3Z M178.9 6.1V80.1H161.8V6.1Z M211.5 23.5Q217 23.5 221.6 25.8Q226.1 28.1 228.7 32V6.1H245.8V80.1H228.7V72.1Q226.3 76.1 221.9 78.5Q217.4 80.9 211.5 80.9Q204.6 80.9 199 77.4Q193.4 73.8 190.2 67.2Q186.9 60.7 186.9 52.1Q186.9 43.5 190.2 37Q193.4 30.5 199 27Q204.6 23.5 211.5 23.5ZM216.5 38.4Q211.4 38.4 207.9 42.1Q204.3 45.7 204.3 52.1Q204.3 58.5 207.9 62.2Q211.4 66 216.5 66Q221.6 66 225.2 62.3Q228.7 58.6 228.7 52.2Q228.7 45.8 225.2 42.1Q221.6 38.4 216.5 38.4Z M255.6 9.3Q255.6 5.3 258.5 2.7Q261.3 0 265.8 0Q270.2 0 273.1 2.7Q275.9 5.3 275.9 9.3Q275.9 13.2 273.1 15.9Q270.2 18.5 265.8 18.5Q261.3 18.5 258.5 15.9Q255.6 13.2 255.6 9.3ZM274.3 24.3V80.1H257.2V24.3Z M306.9 23.5Q312.8 23.5 317.2 25.9Q321.7 28.3 324.1 32.2V24.3H341.2V80.1H324.1V72.2Q321.6 76.1 317.1 78.5Q312.7 80.9 306.8 80.9Q300 80.9 294.4 77.4Q288.8 73.8 285.6 67.2Q282.3 60.7 282.3 52.1Q282.3 43.5 285.6 37Q288.8 30.5 294.4 27Q300 23.5 306.9 23.5ZM311.9 38.4Q306.8 38.4 303.2 42.1Q299.7 45.7 299.7 52.1Q299.7 58.5 303.2 62.2Q306.8 66 311.9 66Q317 66 320.6 62.3Q324.1 58.6 324.1 52.2Q324.1 45.8 320.6 42.1Q317 38.4 311.9 38.4Z M387.2 23.7V41.8H382.5Q376.1 41.8 372.9 44.6Q369.7 47.3 369.7 54.2V80.1H352.6V24.3H369.7V33.6Q372.7 29 377.2 26.4Q381.7 23.7 387.2 23.7Z M451.4 24.3 416.4 106.6H398L410.8 78.2L388.1 24.3H407.2L420.1 59.2L432.9 24.3Z';

/** The app tile: bronze square, bronze-light band, white "bd". `edge` adds the 1 px lighter edge for dark surfaces. */
export function BrandTile({ size = 34, edge = true, label = 'Buildiary' }: { size?: number; edge?: boolean; label?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" role="img" aria-label={label} style={{ flex: 'none' }}>
      <rect x="1" y="1" width="118" height="118" rx="26" fill="var(--brand)" stroke={edge ? 'rgba(196,152,108,.6)' : 'none'} strokeWidth="2" />
      <path d={BAND} fill="var(--brand-300)" />
      <path d={BD} fill="#FFFFFF" />
    </svg>
  );
}

/** The "buildiary" wordmark. White on dark surfaces, neutral-900 on light. */
export function Wordmark({ width = 104, color = '#FFFFFF', className }: { width?: number; color?: string; className?: string }) {
  return (
    <svg className={className} width={width} height={(width * 107) / 452} viewBox="0 0 452 107" aria-hidden="true" style={{ flex: 'none' }}>
      <path d={WORD} fill={color} />
    </svg>
  );
}
